import './index.scss';
import { AgGridReact } from 'ag-grid-react';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { debounce } from 'throttle-debounce';
import { useWorkspaceFolder } from '~/routes/projects_workspace/provider';
import columnDef from './column_def';
export var ColumnName;
(function (ColumnName) {
    ColumnName["Checkbox"] = "checkbox";
    ColumnName["Date"] = "timestamp";
    ColumnName["DocumentName"] = "name";
    ColumnName["FormName"] = "formTitle";
    ColumnName["FormNumber"] = "formNumber";
})(ColumnName || (ColumnName = {}));
const DocumentGrid = () => {
    const gridRef = useRef(null);
    const [gridApi, setGridApi] = useState(null);
    const divRef = useRef(null);
    const { documents } = useWorkspaceFolder();
    const onGridResize = debounce(300, () => { fitGridColumn(); });
    useEffect(() => {
        const resizeObserver = new ResizeObserver(onGridResize);
        resizeObserver.observe(divRef.current);
        return () => { resizeObserver.disconnect(); };
    }, [onGridResize]);
    const [columnDefs] = useState(columnDef());
    const onGridReady = (event) => {
        event.api.showLoadingOverlay();
        setGridApi(event.api);
    };
    const fitGridColumn = () => {
        if (!gridApi)
            return;
        gridApi.sizeColumnsToFit();
        gridApi.hideOverlay();
    };
    const classnames = classNames('ag-theme-alpine', 'document-grid-container', 'rg2-ag-grid-default-style', 'ag-grid-without-border');
    return (React.createElement("div", null,
        React.createElement("div", { className: classnames, ref: divRef },
            React.createElement(AgGridReact, { ref: gridRef, onGridReady: onGridReady, onFirstDataRendered: fitGridColumn, rowData: documents, columnDefs: columnDefs, masterDetail: true, enableCellTextSelection: false, animateRows: true, rowSelection: 'multiple', suppressRowClickSelection: true, suppressCellFocus: true }))));
};
export default DocumentGrid;
